import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { HStack, VStack } from "@chakra-ui/react";
import SelectDepartment from "../components/dashboard_page/select_department";
import GraphicBlock from "../components/dashboard_page/graphic_block";
import LoaderIndicator from "../components/loader_indicator";

import ModalSelectManagers from "../components/modal_select_managers";
import DateFilter from "../components/dashboard_page/date_filter";
import SelectSection from "../components/select_section";

const DashboardPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.resetFilters();
  }, []);

  useEffect(() => {
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/dashboard");
  }, []);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack w={"100%"} marginTop={"20px"} justify={"center"}>
        <DateFilter />
        <ModalSelectManagers />
        <SelectSection />
      </HStack>
      <LoaderIndicator/>
      <GraphicBlock />
    </VStack>
  );
});

export default DashboardPage;
